import Image from 'next/image';
import React from 'react';

import { AIRI } from '@/assets';
import { TokenId, useTokenPrices } from '@/hooks/useTokenPrices';
import { formatCurrency, getUsdWithToken } from '@/utils';

import useTotalLocked from './useTotalLocked';

const TotalLocked = () => {
  const { list } = useTotalLocked();
  const { data: prices } = useTokenPrices();

  return (
    <div className="flex flex-col gap-[20px]">
      {list.map((item) => (
        <div
          key={item.id}
          className="relative overflow-hidden rounded-[18px] bg-white px-8 py-6 shadow-[0px_8px_25px_5px_rgba(199,205,231,0.25)] sm:px-6 sm:py-4"
        >
          <div className="absolute right-0 top-0 rounded-bl-[15px] bg-orange-50 p-3 text-[14px] text-black sm:p-2 sm:text-[12px]">
            {item.label}
          </div>
          <p className="mb-2 sm:text-[14px]">Total locked</p>
          <div className="mb-1 flex items-center">
            <span className="text-[26px] font-semibold lg:text-[22px] sm:text-[18px]">
              {formatCurrency(item.totalLock, 3)}
            </span>{' '}
            <Image
              className="ml-2 max-h-[30px] w-auto lg:max-h-[26px] sm:max-h-[22px]"
              src={AIRI}
              alt="airi"
            />
          </div>
          <span className="text-gray-500 sm:text-[14px]">
            ~$
            {formatCurrency(
              getUsdWithToken({
                amount: item.totalLock,
                tokenId: TokenId.AIRI,
                prices: prices || {},
              }),
              3,
            )}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TotalLocked;
